var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer flex align-center justify-space-between",class:{'above':_vm.position === 'above'}},[_vm._m(0),_c('div',[_c('span',[_vm._v(_vm._s(_vm.versionLabel))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"hidden-xs-only"},[_vm._v("All Rights Reserved - 2019-2020 AER Manufacturing Admin Portal.")])])
}]

export { render, staticRenderFns }